module.exports = __webpack_public_path__ + "static/img/pay.0f4ce371.png";